var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._g(_vm._b({class:{ button: _vm.button, 'is-link': _vm.link },attrs:{"to":_vm.targetRoute,"active-class":"is-active"}},'router-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }